<div class="summary">
    <div class="summary-container" #scroll (scroll)="onScroll()">
        <div class="flex-row">
            <div class="loop-container">
                <div class="title">
                    {{ traductionModal?.summary.titleCardFirst }}
                </div>
                <div class="description">
                    <ng-container
                        *ngIf="
                            data?.firstProduction?.operatorName &&
                            !data?.firstProduction?.machineName &&
                            machineObjCode !== 'JMB'
                        "
                    >
                        {{ "operator" | lang }}
                        {{ data?.firstProduction?.operatorName || "-" }} <br />
                        {{ "extractionpoint" | lang }}
                        {{ data?.firstProduction?.startZoneName || "-" }} /
                        {{ "drainingpoint" | lang }}
                        {{ data?.firstProduction?.endZoneName || "-" }} <br />
                    </ng-container>
                    <ng-container
                        *ngIf="
                            data?.firstProduction?.operatorName &&
                            !data?.firstProduction?.machineName &&
                            machineObjCode === 'JMB'
                        "
                    >
                        {{ "operator" | lang }}
                        {{ data?.firstProduction?.operatorName || "-" }} <br />
                        {{ "point-drilling" | lang }}
                        {{ data?.firstProduction?.startZoneName || "-" }}<br />
                    </ng-container>

                    <ng-container
                        *ngIf="
                            data?.firstProduction?.machineName &&
                            data?.firstProduction?.operatorName &&
                            machineObjCode !== 'JMB'
                        "
                    >
                        {{ "device" | lang }}
                        {{ data?.firstProduction?.machineName || "-" }} <br />
                        {{ "extractionpoint" | lang }}
                        {{ data?.firstProduction?.startZoneName || "-" }} /
                        {{ "drainingpoint" | lang }}
                        {{ data?.firstProduction?.endZoneName || "-" }} <br />
                    </ng-container>
                    <ng-container
                        *ngIf="
                            data?.firstProduction?.machineName &&
                            data?.firstProduction?.operatorName &&
                            machineObjCode === 'JMB'
                        "
                    >
                        {{ "device" | lang }}
                        {{ data?.firstProduction?.machineName || "-" }} <br />
                        {{ "point-drilling" | lang }}
                        {{ data?.firstProduction?.startZoneName || "-" }}<br />
                    </ng-container>
                    {{ "shift" | lang : data?.firstProduction?.shiftName }}
                </div>

                <div class="detail flex-row">
                    <div class="time">
                        {{
                            data?.firstProduction?.datetimeEvent
                                | timePresentation : true
                        }}
                        {{ "hours" | lang }}
                    </div>
                    <div class="street">
                        {{ "street" | lang }}
                        {{ data?.firstProduction?.streetName }}
                    </div>
                </div>
            </div>

            <div class="loop-container">
                <div class="title">
                    {{ traductionModal?.summary?.titleCardSecond }}
                </div>
                <div class="description">
                    <ng-container
                        *ngIf="
                            data?.lastProduction?.operatorName &&
                            !data?.firstProduction?.machineName &&
                            machineObjCode !== 'JMB'
                        "
                    >
                        {{ "operator" | lang }}
                        {{ data?.lastProduction?.operatorName || "-" }} <br />
                        {{ "extractionpoint" | lang }}
                        {{ data?.lastProduction?.startZoneName || "-" }} /
                        {{ "drainingpoint" | lang }}
                        {{ data?.lastProduction?.endZoneName || "-" }}<br />
                    </ng-container>
                    <ng-container
                        *ngIf="
                            data?.lastProduction?.operatorName &&
                            !data?.firstProduction?.machineName &&
                            machineObjCode === 'JMB'
                        "
                    >
                        {{ "operator" | lang }}
                        {{ data?.lastProduction?.operatorName || "-" }} <br />
                        {{ "point-drilling" | lang }}
                        {{ data?.lastProduction?.startZoneName || "-" }} <br />
                    </ng-container>

                    <ng-container
                        *ngIf="
                            data?.lastProduction?.machineName &&
                            data?.firstProduction?.operatorName &&
                            machineObjCode !== 'JMB'
                        "
                    >
                        {{ "device" | lang }}
                        {{ data?.lastProduction?.machineName || "-" }} <br />
                        {{ "extractionpoint" | lang }}
                        {{ data?.lastProduction?.startZoneName || "-" }} /
                        {{ "drainingpoint" | lang }}
                        {{ data?.lastProduction?.endZoneName || "-" }}<br />
                    </ng-container>
                    <ng-container
                        *ngIf="
                            data?.lastProduction?.machineName &&
                            data?.firstProduction?.operatorName &&
                            machineObjCode === 'JMB'
                        "
                    >
                        {{ "device" | lang }}
                        {{ data?.lastProduction?.machineName || "-" }} <br />
                        {{ "point-drilling" | lang }}
                        {{ data?.lastProduction?.startZoneName || "-" }} <br />
                    </ng-container>
                    {{ "shift" | lang : data?.lastProduction?.shiftName }}
                </div>
                <div class="detail flex-row">
                    <div class="time">
                        {{
                            data?.lastProduction?.datetimeEvent
                                | timePresentation : true
                        }}
                        {{ "hours" | lang }}
                    </div>
                    <div class="street">
                        {{ "street" | lang }}
                        {{ data?.lastProduction?.streetName }}
                    </div>
                </div>
            </div>
        </div>

        <div class="loops-table-container">
            <div class="title">
                {{ traductionModal?.summary.titleConsolidate }}
            </div>
            <!-- <div class="title" *ngIf="machineObjCode === 'JMB'">
                {{ "consolidation-loops-drill" | lang }}
            </div> -->
            <app-main-table
                class="loops-table"
                [tableConfig]="tableConfig"
            ></app-main-table>
        </div>
    </div>
    <div
        class="shadow"
        [ngClass]="{
            'shadow-bottom': !disableShadowBottom,
            'shadow-top': !disableShadowTop,
            'shadow-top-bottom': !disableShadowTopBottom
        }"
        [style.width.px]="widthScrollContainer"
    ></div>
</div>
